import { Icon } from '@chakra-ui/react'
const SearchIcon = () => {
  return (
    <Icon viewBox="0 0 24 24" fill="none">
      <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#808080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.9999 20.9999L16.6499 16.6499" stroke="#808080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  )
}

export default SearchIcon